import fun from "../../../util/util";
import myApi from "@/util/my-api";
import myConst from "@/util/my-const";
import Axios from "../../../axios"
import {Message} from "element-ui";

export default {
    namespaced: true,
    state: {
        showDetail:false, //是否显示详情弹窗
        detailDataList:[], //详情数据
        
    },
    mutations: {
        //打开详情弹窗 
        openDetailWindow(state,list){
            state.showDetail = true
            state.detailDataList = list
        },

        // 关闭详情弹窗
        closeDetailWindow(state){
            state.showDetail = false
            state.detailDataList = []
        }
        
    },

    actions:{
       
    }

}
